/**
 * supabase-auth-errors
 *
 * Normalizes Supabase auth failures for logging and recovery paths.
 * GoTrue sometimes returns plain objects (even `{}`) that are not `Error`
 * instances — throwing those surfaces in PostHog as
 * "Object captured as exception with keys: [object has no keys]".
 */

export function getAuthErrorMessage(
  error: unknown,
  fallback = 'Auth request failed'
): string {
  if (error instanceof Error && error.message.trim()) {
    return error.message.trim()
  }

  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message
    if (typeof message === 'string' && message.trim()) {
      return message.trim()
    }
  }

  return fallback
}

export function logSupabaseAuthError(context: string, error: unknown) {
  console.warn(`[auth] ${context}:`, getAuthErrorMessage(error))
}
